export const validNationalCode = new RegExp(

);
export const validPhoneNumber = new RegExp(
   "^(\\+98|0)?9\\d{9}$"
);
export const validCode = new RegExp(
   '^[0-9]{4}$'
);
export const validFixedPhone = new RegExp(
   '^0[0-9]{2,}[0-9]{8,}$'
);
export const validEmail = new RegExp(
   '^[a-zA-Z0-9-_]+@[a-zA-Z0-9]+.[a-zA-Z]{1,10}$'
);
export const validCardNumber = new RegExp(
   '^[0-9]{16}$'
);
export const validNightNumber = new RegExp(
   '^(?:IR)(?=.{24}$)[0-9]*$'
);



